export default __webpack_public_path__ + "img/cKfFkyQq.0475ecdd.svg";